import React from 'react';
import { ISelectOption, ISpruceFieldProps, PhoneNumberInput, Select, SpruceField, TextInput } from 'ui-toolkit';
import { OrderContactNotesField } from '../subComponents/OrderContactNotesField';
import { activeClientContactsFunctionsOptions } from '../../../../types/contacts/activeClientContactsFunctionsOptions';
import { useListContactFunctionsQuery } from '../../../../API/contacts/ContactFunctionsApi';
import { getContactFunctionValue } from '../../../../utilities/contact/getContactFunctionValue';

interface IClientOrderContactFormProps {
  emailReadOnly: boolean;
}

export const ClientOrderContactForm: React.FC<IClientOrderContactFormProps> = ({ emailReadOnly }) => {
  const { data: contactFunctions = [] } = useListContactFunctionsQuery();
  return (
    <>
      <SpruceField name={'firstName'}>
        {({ field }: ISpruceFieldProps) => <TextInput {...field} label={'First Name'} isRequired />}
      </SpruceField>
      <SpruceField name={'middleName'}>
        {({ field }: ISpruceFieldProps) => <TextInput {...field} label={'Middle Name'} />}
      </SpruceField>
      <SpruceField name={'lastName'}>
        {({ field }: ISpruceFieldProps) => <TextInput {...field} label={'Last Name'} isRequired />}
      </SpruceField>
      <SpruceField name={'functions'}>
        {({ field }: ISpruceFieldProps) => (
          <Select
            {...field}
            onChange={(values: ISelectOption[]) => field.onChange(values.map((value) => value.value))}
            value={getContactFunctionValue(field.value, contactFunctions)}
            options={activeClientContactsFunctionsOptions(contactFunctions)}
            isClearable={true}
            isMulti={true}
            isRequired={true}
            label={'Function(s)'}
          />
        )}
      </SpruceField>
      <SpruceField name={'email'}>
        {({ field, formik }: ISpruceFieldProps) => (
          <TextInput
            {...field}
            onBlur={() => formik.setFieldTouched(field.name)}
            label={'Email'}
            isRequired
            readOnly={emailReadOnly}
          />
        )}
      </SpruceField>
      <SpruceField name={'companyName'}>
        {({ field }: ISpruceFieldProps) => <TextInput {...field} label={'Company Name'} />}
      </SpruceField>
      <SpruceField name={'phoneNumber'}>
        {({ field }: ISpruceFieldProps) => <PhoneNumberInput {...field} label={'Phone Number'} />}
      </SpruceField>
      <OrderContactNotesField name={'notes'} />
    </>
  );
};
